import boxShadows from 'assets/theme/base/box-shadows';
import typography from 'assets/theme/base/typography';
import colors from 'assets/theme/base/colors';
import borders from 'assets/theme/base/borders';
import pxToRem from 'assets/theme/function/px-to-rem';
import { breakpoints } from 'assets/theme/base/breakpoints';

const { xs } = boxShadows;
const { size } = typography;
const { common } = colors;
const { borderRadius } = borders;

const autoComplete = {
    styleOverrides: {
        /*inputRoot: {
            padding: `${pxToRem(0)} 0 ${pxToRem(2)} ${pxToRem(8)}`,
            minHeight: pxToRem(48),
            height: 'auto',
        },*/

        popper: {
            boxShadow: xs,
            borderRadius: borderRadius.sm,
        },

        paper: {
            boxShadow: 'none',
            backgroundColor: colors.action.menu,
            borderRadius: borderRadius.sm,
        },

        inputRoot: {
            minHeight: pxToRem(48),
            padding: `0 ${pxToRem(8)} 0 ${pxToRem(8)}`,

            '& .MuiAutocomplete-input': {
                padding: `${pxToRem(8)} 0 ${pxToRem(8)} ${pxToRem(8)}`,

                [breakpoints.down('sm')]: {
                    padding: `${pxToRem(14)} 0 ${pxToRem(14)} ${pxToRem(10)}`,
                },
            },

            '& .MuiSvgIcon-root': {
                [breakpoints.down('sm')]: {
                    fontSize: pxToRem(18),
                },
            },
        },

        clearIndicator: {
            color: common.white,
        },

        popupIndicator: {
            color: common.white,
        },

        option: {
            padding: `${pxToRem(10)} ${pxToRem(17)}`,
            fontSize: size.sm,
            color: common.white,

            '&:hover, &:focus, & .Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus':
                {
                    backgroundColor: colors.common.white,
                },

            '&[aria-selected="true"]': {
                color: common.white,
            },

            '& .MuiSvgIcon-root': {
                [breakpoints.down('sm')]: {
                    fontSize: pxToRem(18),
                },
            },
        },
        tag: {
            //height: pxToRem(25),
            //fontSize: size.xs,
            backgroundColor: colors.common.white,

            '& .MuiChip-label': {
                lineHeight: 1.2,
            },
        },
    },
};

export default autoComplete;
